import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

function Library() {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const { lang } = useLanguage();

  return (
    <div className="relative w-full h-full flex overflow-hidden">
      {/* BACKGROUND */}
      <img
        src="/bg/library.webp"
        className="absolute inset-0 w-full h-full object-cover object-center"
        alt="background"
      />

      {/* BOOK */}
      <motion.img
        src="/lib/marmoris.webp"
        alt="marmoris book"
        className="absolute object-cover w-[17%] top-[42%] left-[46%] md:w-[11%] md:top-[41%] md:left-[47%] xl:w-[5%] xl:top-[37%] xl:left-[49%] cursor-pointer"
        onClick={() => navigate("/marmoris")}
        whileHover={{ scale: 1.05 }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      />

      {/* TAG IMAGE (appears only on hover) */}
      <motion.div
        className="absolute top-[280px] left-[900px] pointer-events-none"
        initial={{ opacity: 0, x: 10, scale: 0.95 }}
        animate={hovered ? { opacity: 1, x: 0, scale: 1 } : { opacity: 0, x: 10, scale: 0.95 }}
        transition={{ duration: 0.25 }}
      >
        {/* Tag image */}
        <div className="relative items-center justify-center">
          <img
            src="/lib/tag.webp"
            alt="tag"
            className="w-fit object-contain"
          />

          {/* TEXT inside tag */}
          <p className={`absolute left-5 top-6 text-black font-semibold w-[400px] leading-tight ${lang == "TH" ? "font-thai text-sm" : "font-eng text-xs"}`}>
            {lang == "TH" ? "Mystery of Marmoris นิยายเรื่องแรกจาก Once A Live Project" : "Mystery of Marmoris is the first novel from Once A Live Project"}
          </p>
          <p className={`absolute left-5 top-14 text-black font-semibold w-[400px] leading-tight ${lang == "TH" ? "font-thai text-sm" : "font-eng text-xs"}`}>
            {lang == "TH" ? "ได้รับแรงบันดาลใจจากปัญหาในชีวิตประจำวัน โลกใต้ทะเล และกลิ่นอายการสืบสวนแบบเชอร์ล็อก โฮล์มส์ นำเสนอผ่านแนวสืบสวน-แฟนตาซี ลองอ่านและดำดิ่งไปด้วยกัน!" : "Inspired by everyday issues, the underwater world, and the classic investigative atmosphere of Sherlock Holmes, the story is presented through a blend of mystery and fantasy. Join us and dive into the world of Marmoris together!"}
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default Library;
